import { Link } from "react-router-dom";
import MarketingPage from "./_shared/MarketingPage";
import { Swoosh } from "./_shared/Hero";

export default function GeschenkOma() {
  return (
    <MarketingPage
      eyebrow="Geschenk · für Oma"
      h1={
        <>
          Das Geschenk für Oma, das nur sie <Swoosh>geben</Swoosh> kann
        </>
      }
      lead={
        <>
          Was schenkt man einer Frau, die ein Leben hinter sich hat, in dem
          sie selten an sich gedacht hat? Eine weitere Kerze, ein weiteres
          Tuch, ein weiterer Bildband — das alles funktioniert, aber es
          bleibt nicht. <strong>Ein Buch mit Omas Lebensgeschichte</strong>{" "}
          bleibt. Und die einzige Person, die es schreiben kann, ist sie
          selbst.
          <br />
          <br />
          Mit Vitanara erzählt Oma am Telefon. Wann immer sie mag, so lang
          sie mag. Konrad und Ida hören zu. Nach rund zwölf Wochen halten
          Sie ein in Leinen gebundenes Buch in der Hand — ihres.
        </>
      }
      sections={[
        {
          h2: "Warum klassische Oma-Geschenke nicht mehr ankommen",
          body: (
            <p style={{ margin: 0 }}>
              Mit Anfang Achtzig haben die meisten Großmütter zwölf
              Lebkuchenherzen, vier Bademäntel und drei Bildbände über die
              Toskana zu Hause. Was ihnen oft fehlt, sind Stunden, in denen
              jemand zuhört. Vitanara liefert genau das — über zwölf Wochen,
              unaufdringlich, am Telefon, in ihrem Tempo. Und am Ende ein
              Buch, das die Enkel und Urenkel noch in dreißig Jahren lesen.
            </p>
          ),
        },
        {
          h2: "Anlässe, zu denen sich Vitanara für Oma besonders eignet",
          body: (
            <>
              <p style={{ margin: "0 0 10px" }}>
                <strong>Runder Geburtstag.</strong> Zum 80., 85. oder 90. ist
                die Lebensbilanz ohnehin nah — Vitanara gibt ihr Form.
              </p>
              <p style={{ margin: "0 0 10px" }}>
                <strong>Goldene oder diamantene Hochzeit.</strong> Wenn Oma
                und Opa gemeinsam erzählen, entsteht ein Buch mit zwei
                Stimmen. Mehr dazu auf{" "}
                <Link
                  to="/goldene-hochzeit-geschenk"
                  style={{ color: "var(--oxblood)", textDecoration: "none" }}
                >
                  Goldene Hochzeit Geschenk
                </Link>
                .
              </p>
              <p style={{ margin: "0 0 10px" }}>
                <strong>Muttertag.</strong> Statt Blumen, die in einer Woche
                verwelken, ein Versprechen: „Mama, in zwölf Wochen liest du
                dich selbst.“
              </p>
              <p style={{ margin: 0 }}>
                <strong>Weihnachten.</strong> Das Buch unter dem Baum — und
                am Heiligabend wird gemeinsam vorgelesen. Drei Stunden lang,
                mit Pausen für Taschentücher.
              </p>
            </>
          ),
        },
        {
          h2: "Was Oma während der Anrufe erlebt",
          body: (
            <>
              <p style={{ margin: "0 0 12px" }}>
                Die meisten Großmütter sind nach den ersten zwei, drei
                Anrufen lockerer als sie selbst erwartet haben. Konrad und
                Ida fragen nach, wenn etwas interessant klingt, und
                schweigen, wenn Oma ihren Gedanken folgen will.
              </p>
              <p style={{ margin: 0 }}>
                Schwere Themen — Krieg, Verlust, Schicksalsschläge — werden
                nicht erzwungen. Wenn Oma davon erzählen möchte, ist Platz.
                Wenn nicht, auch.
              </p>
            </>
          ),
        },
        {
          h2: "Was Enkel über Vitanara sagen",
          body: <p style={{ margin: 0 }}>Zwei Stimmen aus der Familie:</p>,
          quote: {
            text: "Ich höre meinen Opa noch heute reden, wenn ich das Buch aufschlage. Das gibt es sonst nirgends.",
            who: "Marie, 41 · Enkelin",
          },
        },
        {
          h2: "Noch eine Stimme",
          body: (
            <p style={{ margin: 0, fontStyle: "italic" }}>
              Manche Großeltern sind nach Wochen lockerer als nach Jahren
              Sonntagskaffee.
            </p>
          ),
          quote: {
            text: "Oma greift inzwischen fast jeden Tag zum Hörer. Plötzlich erzählt sie Geschichten, die niemand kannte.",
            who: "Jonas, 38 · Enkel",
          },
        },
      ]}
      faqs={[
        {
          q: "Meine Oma ist 92 – geht das?",
          a: "Ja. Vitanara wird häufig für Hochbetagte gewählt. Wichtig ist nur, dass sie ein normales Telefongespräch führen kann.",
        },
        {
          q: "Was, wenn Oma hartnäckig nicht erzählen will?",
          a: "Wir empfehlen, ihr die Karte einfach hinzulegen, ohne Erwartung. Viele rufen nach Tagen oder Wochen aus eigener Neugier doch an.",
        },
        {
          q: "Bekommen alle Enkel ein eigenes Exemplar?",
          a: "Ein leinengebundenes Exemplar ist enthalten. Zusätzliche Exemplare können bestellt werden – viele Familien drucken so viele wie es Enkel gibt.",
        },
      ]}
      crossLinks={[
        {
          to: "/geschenk-fuer-opa",
          label: "Geschenk für Opa",
          blurb: "Auch Großväter haben Geschichten — meistens mehr als gedacht.",
        },
        {
          to: "/goldene-hochzeit-geschenk",
          label: "Goldene Hochzeit Geschenk",
          blurb: "Fünfzig Jahre Ehe als gemeinsames Buch mit zwei Stimmen.",
        },
        {
          to: "/wie-funktioniert-vitanara",
          label: "Wie funktioniert Vitanara?",
          blurb: "Vom Anruf bis zum leinengebundenen Buch in zwölf Wochen.",
        },
      ]}
    />
  );
}
